module.exports = __webpack_public_path__ + "img/green_088.3811797a.png";